import {
  Button,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  Stack,
  Switch,
  TextField,
  Typography,
  styled,
  useTheme,
} from "@mui/material";
import { DataGrid, GridActionsCellItem } from "@mui/x-data-grid";
import SearchIcon from "@mui/icons-material/Search";
import { toast } from "react-toastify";
import React, { useCallback, useEffect, useRef, useState } from "react";
// import "rsuite/dist/rsuite.min.css";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { guestListFailed, guestListSuccess } from "../../Reducer/reportSlice";
// import TextareaAutosize from "@mui/base/TextareaAutosize";

// import { IColumn } from "../../../models/base-type";
import {  useDispatch, connect } from "react-redux";
import DialogForm from "../../shared/components/DialogForm";
import ReservationCheckIn from "./ReservationCheckIn";
import ReservationCheckOut from "./ReservationCheckOut";
import MakePaymentDialog from "./MakePaymentDialog";
import moment from "moment";
import { ApiEndPoints } from "../../apis/ApiEndPoints";
import {
  createRecord,
  deleteRecord,
  fetchList,
  getRecord,
  sendEmail,
  sendSms,
  updateCardRecord,
} from "../../apis/services/CommonApiService";
import { rowsPerPageJsonData } from "../../utils/JsonData";
import ConfirmDialog from "../../shared/components/ConfirmDialog";
import { useTranslation } from "react-i18next";
import Loader from "../../layout/Loader";
import { SendSmsDialog } from "./ReservationActions/SendSmsReservationDialog";
import { PiChatCircleDotsDuotone } from "react-icons/pi";
import { ChangeReservationStatus } from "./ReservationActions/ChangeStatusReservationDialog";
import ChangeStatusReservationDialog from "./ReservationActions/ChangePaymentTypeDialog";
import { getLoadingFailed, getLoadingSuccess } from "../../Reducer/authSlice";
import {
  reservationViewChange,
  reservationViewReset,
} from "../../Reducer/FilterSlice";
import { cleanHexId, cryptoEncryptData, getLanguageCode, getMinDateForLimited } from "../../utils/helper";
import { DatePicker } from "@mui/x-date-pickers";
import { ExportToExelCompo } from "../Reports/ExpoertExel/ExportToExelCompo";
import ReactToPrint from "react-to-print";
import ReservationPrint from "./ReservationPrint/ReservationPrint";
import { dataReservationListSuccess, handleTriggerLoadingFailed, handleTriggerLoadingSuccess, otaCodeListFailed, otaCodeListSuccess, pinpadDevicesListFailed, pinpadDevicesListSuccess } from "../../Reducer/reservationListSlice";
import { VerifyCard } from "../../apis/services/VerifyCard";
import UpdateTaxPopup from "./ReservationActions/UpdateTaxDialog";
import { getPermission, getPermissionList } from "../../utils/helper";

const label = { inputProps: { "aria-label": "Size switch demo" } };

export const IOSSwitch = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(16px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor:
          theme.palette.mode === "dark" ? "#2ECA45" : "rgb(28, 58, 102)",
        opacity: 1,
        border: 0,
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5,
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "#33cf4d",
      border: "6px solid #fff",
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      color:
        theme.palette.mode === "light"
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 22,
    height: 22,
  },
  "& .MuiSwitch-track": {
    borderRadius: 26 / 2,
    backgroundColor: theme.palette.mode === "light" ? "#E9E9EA" : "#39393D",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
  },
}));

const ReservationView = (props) => {
  const theme = useTheme();

  const {
    handleTriggerLoadingSuccess,
    handleTriggerLoadingFailed,
    handleTriggerLoading,
    dataReservationList,
    dataReservationListSuccess,
    guestList,
    guestListSuccess,
    guestListFailed,
    getLoadingSuccess,
    getLoadingFailed,
    setSearchFilters,
    searchFilters,
    reservationViewReset,
    otaCodeList,
    otaCodeListSuccess,
    otaCodeListFailed,
    pinpadDevicesList,
    pinpadDevicesListSuccess,
    pinpadDevicesListFailed
  } = props;
  // const { checkInCheckOutList } = props;
  const { t } = useTranslation();
  let [searchParams] = useSearchParams();
  const [openDialog, setOpenDialog] = React.useState(false);
  const [openDialogout, setOpenDialogout] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const componentRef = useRef();
  const [suOn, setSuOn] = useState(false);
  const [suToken, setSuToken] = useState(null);
  const [isCashAllowed, setIsCashAllowed] = useState(0);

  const handleSuOn = (e) => {
    setSuOn(e.target.checked);
  };

  // console.log(cryptoEncryptData("123"))

  const [yearList, setYearList] = useState([]);
  const month = [
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
  ];

  useEffect(() => {
    // const items = JSON.parse(localStorage.getItem("userDetails"));
    // if (items) {
    //   setHotelId(items.hotel_id);
    // }
    let currentMonth = moment().format("YYYY");
    let yearArray = [];
    for (let i = 0; i < 100; i++) {
      yearArray.push((i + Number(currentMonth)).toString());
    }
    setYearList(yearArray);
  }, []);

  const navigate = useNavigate();

  // const formData = useSelector((state) => state.filters);
  // console.log(formData, 180);

  // const [searchFilters, setSearchFilters] = useState({
  //   startDate: moment().format("YYYY-MM-DD"),
  //   // endDate: moment().endOf("month").format("YYYY-MM-DD"),
  //   endDate: moment().add(7, "days").format("YYYY-MM-DD"),
  //   search_text: "",
  //   booking_status: 0,
  //   booking_source: 0,
  //   search_in_booking: 0,
  // });

  // const [dataReservationList, setDataReservationList] = useState({
  //   loading: false,
  //   rows: [],
  //   totalRows: 0,
  //   rowsPerPageOptions: rowsPerPageJsonData,
  //   pageSize: 10,
  //   page: 1,
  // });

  const [datagridPrintOptions, setDatagridPrintOptions] = useState({
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 100000,
    page: 1,
  });

  // console.log(dataReservationList.rows, 217);

  const setDatagridRowsData = (data) => {
    if (data.length > 0) {
      const ratesDatagridRows = data?.map((item, index) => {
        return {
          id: `#${String(item.id).padStart(6, "0")}`,
          booking_id: item?.id,
          booking_date: moment(item?.booking_date, "YYYY-MM-DD").format(
            "MM/DD/YYYY"
          ),
          name: item?.userData?.name,
          room_type: item?.bookingItemsData
            ?.filter(
              (obj, index) =>
                index ===
                item?.bookingItemsData?.findIndex(
                  (o) =>
                    obj?.roomCategoryDetail?.roomcategory_name ===
                    o?.roomCategoryDetail?.roomcategory_name
                )
            )
            ?.map((ele, i) => " " + ele?.roomCategoryDetail?.roomcategory_name),
          no_of_days: item?.no_of_days,
          booking_status: item.bookingStatusInfo?.status,
          booking_status_id: item?.bookingStatusInfo?.id,
          // userBookingCount: item?.userBookingCount,
          checkin_date: moment(item?.checkin_date, "YYYY-MM-DD").format(
            "MM/DD/YYYY"
          ),
          checkout_date: moment(item?.checkout_date, "YYYY-MM-DD").format(
            "MM/DD/YYYY"
          ),
          final_amount: item?.final_amount,
          booking_type:
            (item?.is_corporate_booking === 1 ? t("Corporate - ") : "") +
            (item?.booking_type === 1
              ? t("Single")
              : t("Group") + "-" + (item?.primary_booking_id === 0 ? "P" : "S")),
          // final_amount: item?.final_amount,
          bookingSource:
            item?.booking_source == 1
              ? t("Admin")
              : item?.booking_source == 2
              ? t("App")
              : item?.booking_source == 3
              ? t("OTA") + "-" + item?.ota_source
              : item?.booking_source == 4
              ? t("Web")
              : "-",
          bookingSourceId: item?.booking_source,
          user_id: item?.user_id,
          card_present: item?.card_present,
          payment_type: item?.payment_type,
          terminal_id: item?.terminal_id,
          secondary_user_id: item?.comm_user_id,
        };
      });
      updateReservationList("rows", ratesDatagridRows);
    } else {
      updateReservationList("rows", []);
    }
  };

  useEffect(() => {
    setDatagridRowsData(guestList);
    // console.log(247, guestList)
  }, [guestList]);

  const updateReservationList = (k, v) => dataReservationListSuccess({key:k, value:v});
    // setDataReservationList((prev) => ({ ...prev, [k]: v }));

  const updatedatagridPrintOptions = (k, v) =>
    setDatagridPrintOptions((prev) => ({ ...prev, [k]: v }));

  const getReservationList = useCallback(async () => {
    console.log()
    if(!handleTriggerLoading){
      updateReservationList("loading", true);
    }
    const result = await fetchList(
      ApiEndPoints.GET_RESERVATIONS +
        `?page_no=${dataReservationList.page}&items_per_page=${
          dataReservationList.pageSize
        }&start_date=${searchFilters.startDate}&end_date=${
          searchFilters.endDate
        }&search_text=${+searchFilters?.search_in_booking === 1 ?
          cleanHexId(searchFilters.search_text) :
          searchFilters.search_text}&booking_status=${
          searchFilters.booking_status
        }&booking_source=${
          searchFilters?.booking_source
        }&user_id=${searchParams?.get("user_id")}&search_in_booking=${
          searchFilters?.search_in_booking
        }&${
          searchFilters?.booking_source == 3 && searchFilters?.ota_source !== 0
            ? "ota_source=" + searchFilters?.ota_source
            : ""
        }&corporate_bookings=${searchFilters?.booking_type}&payment_type=${searchFilters?.payment_type}`
    );
    if (result?.status === 200) {
      updateReservationList("totalRows", result.data.totalRows);
      // console.log(result.data.rows, 2477)
      if (JSON.stringify(result?.data?.rows) !== JSON.stringify(guestList)){
          guestListSuccess(result.data.rows);
        }
        handleTriggerLoadingSuccess();
      // setDatagridRowsData(result.data.rows);
      updateReservationList("loading", false);
      // console.log(result.data.rows,262);
    } else {
      updateReservationList("totalRows", 0);
      setDatagridRowsData([]);
      guestListFailed();
      updateReservationList("loading", false);
      handleTriggerLoadingSuccess();
    }
  }, [
    dataReservationList?.page,
    dataReservationList?.pageSize,
    searchFilters?.startDate,
    searchFilters?.endDate,
    searchFilters?.booking_status,
    searchFilters?.booking_source,
    searchFilters?.ota_source,
    searchFilters?.search_text,
    searchFilters?.search_in_booking,
    searchFilters?.booking_type,
    searchFilters?.payment_type,
    searchParams?.get("user_id"),
    searchParams,
  ]);
  const [isPrinting, setIsPrinting] = useState(false);
  const promiseResolveRef = useRef(null);

  useEffect(() => {
    if (isPrinting && promiseResolveRef.current) {
      promiseResolveRef.current();

      // Resolves the Promise, letting `react-to-print` know that the DOM updates are completed
    }
  }, [isPrinting]);

  const datagridExelColumns = [
    {
      field: "id",
      headerName: t("Confirmation#"),
      flex: 1,
    },
    { field: "name", headerName: t("Guests"), flex: 1 },
    { field: "city", headerName: t("City"), flex: 1 },
    { field: "pincode", headerName: t("Pincode"), flex: 1 },
    { field: "state", headerName: t("State"), flex: 1 },
    {
      field: "booking_status",
      headerName: t("Status"),
      flex: 1,
    },
    { field: "booking_date", headerName: t("Booking Date"), flex: 1 },
    { field: "checkin_date", headerName: t("Check In"), flex: 1 },
    { field: "checkout_date", headerName: t("Check Out"), flex: 1 },
    { field: "pickup_margin", headerName: t("Pickup Margin"), flex: 1 },
    { field: "room_type", headerName: t("Room Type"), flex: 1 },
    {
      field: "booking_type",
      headerName: t("Booking Type"),
      flex: 1,
    },
    {
      field: "bookingSource",
      headerName: t("Booking Source"),
      flex: 1,
    },
    { field: "final_amount", headerName: t("Amount"), flex: 0.9 },
  ];

  const getReservationPrintList = async (type) => {
    updatedatagridPrintOptions("loading", true);
    setLoading(true);
    const result = await fetchList(
      ApiEndPoints.GET_RESERVATIONS +
        `?page_no=${datagridPrintOptions.page}&items_per_page=${
          datagridPrintOptions.pageSize
        }&start_date=${searchFilters.startDate}&end_date=${
          searchFilters.endDate
        }&search_text=${searchFilters.search_text}&booking_status=${
          searchFilters.booking_status
        }&booking_source=${
          searchFilters?.booking_source
        }&user_id=${searchParams?.get("user_id")}&search_in_booking=${
          searchFilters?.search_in_booking
        }&${
          searchFilters?.booking_source == 3 && searchFilters?.ota_source !== 0
            ? "ota_source=" + searchFilters?.ota_source
            : ""
        }&corporate_bookings=${searchFilters?.booking_type}&payment_type=${searchFilters?.payment_type}`
    );

    if (result?.status === 200) {
      updatedatagridPrintOptions("totalRows", result.data.totalRows);
      // console.log(result.data.rows, 2477)
      // guestListSuccess();
      const ratesDatagridRows = result.data?.rows?.map((item, index) => {
        return {
          id: `#${String(item.id).padStart(6, "0")}`,
          booking_id: item?.id,
          booking_date: moment(item?.booking_date, "YYYY-MM-DD").format(
            "MM/DD/YYYY"
          ),
          name: item?.userData?.name,
          room_type: item?.bookingItemsData
            ?.filter(
              (obj, index) =>
                index ===
                item?.bookingItemsData?.findIndex(
                  (o) =>
                    obj?.roomCategoryDetail?.roomcategory_name ===
                    o?.roomCategoryDetail?.roomcategory_name
                )
            )
            ?.map((ele, i) => " " + ele?.roomCategoryDetail?.roomcategory_name)
            .join(", "),
          no_of_days: item?.no_of_days,
          booking_status: item.bookingStatusInfo?.status,
          booking_status_id: item?.bookingStatusInfo?.id,
          // userBookingCount: item?.userBookingCount,
          checkin_date: moment(item?.checkin_date, "YYYY-MM-DD").format(
            "MM/DD/YYYY"
          ),
          checkout_date: moment(item?.checkout_date, "YYYY-MM-DD").format(
            "MM/DD/YYYY"
          ),
          pickup_margin: moment(item?.checkin_date, "YYYY-MM-DD").diff(
            moment(item?.booking_date, "YYYY-MM-DD"),
            "days"
          ),
          final_amount: item?.final_amount,
          booking_type:
            (item?.is_corporate_booking === 1 ? t("Corporate - ") : "") +
            (item?.booking_type === 1
              ? t("Single")
              : t("Group") + "-" + (item?.primary_booking_id === 0 ? "P" : "S")),
          // final_amount: item?.final_amount,
          bookingSource:
            item?.booking_source == 1
              ? t("Admin")
              : item?.booking_source == 2
              ? t("App")
              : item?.booking_source == 3
              ? t("OTA") + "-" + item?.ota_source
              : item?.booking_source == 4
              ? t("Web")
              : "-",
          bookingSourceId: item?.booking_source,
          user_id: item?.user_id,
          card_present: item?.card_present,
          payment_type: item?.payment_type,
          terminal_id: item?.terminal_id,
          secondary_user_id: item?.comm_user_id,
          city: item?.userData?.userDetail?.city_id,
          pincode: item?.userData?.userDetail?.postal_code,
          state: item?.userData?.userDetail?.state_id,
        };
      });
      updatedatagridPrintOptions("rows", ratesDatagridRows);
      // setDatagridRowsData(result.data.rows);
      // console.log(ratesDatagridRows, 438);
      updatedatagridPrintOptions("loading", false);

      if (type === 1) {
        // console.log(datagridExelColumns, 487);
        ExportToExelCompo({
          searchFilters,
          datagridPrintOptions: {
            ...datagridPrintOptions,
            rows: ratesDatagridRows,
            totalRows: result.data.totalRows,
          },
          datagridColumns: datagridExelColumns,
          name: "Reservation List",
          title: `Reservation List ${searchFilters?.startDate} to ${searchFilters?.endDate}`,
        });
      }
      if (promiseResolveRef.current) {
        setIsPrinting(true);
      }
      setLoading(false);

      // console.log(result.data.rows,262);
    } else {
      // console.log(datagridExelColumns, 507);

      updatedatagridPrintOptions("totalRows", 0);
      updatedatagridPrintOptions("rows", []);
      if (type === 1) {
        ExportToExelCompo({
          searchFilters,
          datagridPrintOptions: {
            ...datagridPrintOptions,
            rows: [],
            totalRows: 0,
          },
          datagridColumns: datagridExelColumns,
          name: "Reservation List",
          title: `Reservation List ${searchFilters?.startDate} to ${searchFilters?.endDate}`,
        });
      }
      // setDatagridRowsData([]);
      // guestListFailed();
      updatedatagridPrintOptions("loading", false);
      if (promiseResolveRef.current) {
        setIsPrinting(true);
      }
      setLoading(false);
    }
  };

  useEffect(() => {
    if (searchParams?.get("user_id")) {
      setSearchFilters({
        ...searchFilters,
        startDate: moment().subtract(2, "years").format("YYYY-MM-DD"),
        endDate: moment().add(2, "years").format("YYYY-MM-DD"),
      });
      handleTriggerLoadingFailed();
      updateReservationList("page", 1);
    }
  }, [searchParams?.get("user_id")]);

  const [selectDetail, setSelectDetail] = useState("");
  const handleBookingStatus = async (params, val) => {
    // console.log(params?.row?.payment_type,268)
    setPaymentType(2);
    setUser_id(params?.row?.user_id);
    setCard({
      id: 0,
      user_id: "",
      card_holder_name: "",
      card_number: "",
      yyy: "",
      mm: "",
      cvv: "",
    });
    setCard_present(params?.row?.card_present == 1);
    const bodyFormData = {
      booking_id: params?.row?.booking_id,
      booking_status: val == 1 ? 5 : 6,
    };
    const result = await fetchList(
      ApiEndPoints.GET_BOOKING_DETAILS + `/${params?.row?.booking_id}`
    );
    // console.log(result?.data, 288);
    if (result.data.bookingPaymentDetails) {
      setIsCashAllowed(result?.data?.hotelData?.is_cash_allowed);
      setCard({
        id: result?.data?.bookingPaymentDetails?.cardDetail?.id || 0,
        user_id: result?.data?.bookingPaymentDetails?.cardDetail?.user_id,
        card_holder_name:
          result?.data?.bookingPaymentDetails?.cardDetail?.card_holder_name,
        card_number:
          result?.data?.bookingPaymentDetails?.cardDetail?.card_number,
        yyy: result?.data?.bookingPaymentDetails?.cardDetail?.expiry_date.split(
          "-"
        )[0],
        mm: result?.data?.bookingPaymentDetails?.cardDetail?.expiry_date.split(
          "-"
        )[1],
        cvv: result?.data?.bookingPaymentDetails?.cardDetail?.cvv,
        card_type: result?.data?.bookingPaymentDetails?.cardDetail?.card_type,
      });
    }
    setSelectDetail(result?.data);
    setReservationStatus(bodyFormData);

    if (result.data?.commUserData?.id) {
      setSmsUserDetail([
        {
          id: result.data?.commUserData?.id,
          phone_code: result.data?.commUserData?.phone_code,
          mobile: result.data?.commUserData?.mobile,
          email: result.data?.commUserData?.email,
          name: result.data?.commUserData?.name,
        },
        {
          id: result.data?.userData?.id,
          phone_code: result.data?.userData?.phone_code,
          mobile: result.data?.userData.mobile,
          email: result.data?.userData.email,
          name: result.data?.userData.name,
        },
      ]);

      setSmsInitialValue((prevState) => ({
        ...prevState,
        phone_code: result.data?.commUserData?.phone_code,
        phone_number: result.data?.commUserData?.mobile,
      }));
      setEmailInitialValue((prevState) => ({
        ...prevState,
        email: result.data?.commUserData?.email,
      }));
    } else {
      setSmsUserDetail([]);
      setSmsInitialValue((prevState) => ({
        ...prevState,
        phone_code: result?.data?.userData?.phone_code,
        phone_number: result?.data?.userData?.mobile,
      }));
      setEmailInitialValue((prevState) => ({
        ...prevState,
        email: result?.data?.userData?.email,
      }));
    }

    if (val == 1) {
      setOpenCancelReservationDialog(true);
    }
    if (val == 2) {
      setOpenNoShowReservationDialog(true);
    }
    if (val == 3) {
      setOpenVoidDialog(true);
    }
    if (val == 4) {
      setOpenRefundDialog(true);
    }
    if (val == 5) {
      setOpenChangePaymentDialog(true);
      setUser_id(params?.row?.user_id);
      getCradsDetail(params?.row?.user_id);
    }
    if (val == 6) {
      setOpenSendSmsDialog(true);
      // console.log(result?.data?.userData, 309);
    }
    if (val == 7) {
      setOpenChangePaymentTypeDialog(true);
      getPinpadDevicesDetail();
      // handleEdit(params.row.booking_id, 0);
      setSelectPinpadDevices(params?.row?.terminal_id);
      setPaymentType(params?.row?.payment_type);
      setUser_id(params?.row?.user_id);
      getCradsDetail(params?.row?.user_id);
      // console.log(params, 391);
    }
    if (val == 8) {
      setOpenChangeBookingStatus(true);
    }
    if (val == 9) {
      setOpenRemarkDialog(true);
    }
    if (val == 10) {
      setOpenConfirmDeleteDuplicateDialog(true);
    }
    if( val == 11 ){
      setOpenFixTaxDialog(true);
    }
  };

  const dispatch = useDispatch();

  const [editedData, setEditedData] = useState();
  const handleEdit = async (id, checkInOut) => {
    dispatch(getLoadingSuccess());

    const result = await fetchList(ApiEndPoints.GET_BOOKING_DETAILS + `/${id}`);
    if (result?.status === 200) {
      setEditedData(result.data);
      if (result?.data?.su_pg_id) {
        setSuToken(result?.data?.su_pg_id);
        setSuOn(true);
      } else {
        setSuToken(null);
        setSuOn(false);
      }
      dispatch(getLoadingFailed());
    } else {
      setEditedData([]);
      dispatch(getLoadingFailed());
    }
    if (checkInOut == 1) {
      // if (result?.data?.agreementDetails !== null) {
      handleDialogOpen();
      // } else {
      //   toast.info("Please Sign Agreement");
      // }
    }
    if (checkInOut == 2) {
      handleDialogOutOpen();
    }
    if (checkInOut == 3) {
      setOpenFixTaxDialog(true);
    }
  };



  useEffect(() => {
    if (searchFilters?.startDate && searchFilters?.endDate ) {
      getReservationList();
    }
  }, [getReservationList]);

  // useEffect(() => {
  //   if (searchFilters?.startDate && searchFilters?.endDate) {
  //     getReservationPrintList();
  //   }
  // }, [getReservationPrintList]);

  // Cancel Reservation
  const [openCancelReservationDialog, setOpenCancelReservationDialog] =
    React.useState(false);
  const handleCloseCancelReservationDialog = () =>
    setOpenCancelReservationDialog(false);
  const [reservationStatus, setReservationStatus] = useState();

  const handleConfirmCancelReservationAction = async (send_sms) => {
    setOpenConfirmSendSmsEmailDialog(false);
    setLoading(true);
    setOpenCancelReservationDialog(false);
    let now = moment(new Date());
    let end = moment(selectDetail?.checkin_date);
    let duration = moment.duration(end?.diff(now));
    let calculatedHours = duration?.asHours();
    const result = await createRecord(
      {
        ...reservationStatus,
        send_sms: send_sms,
        total_hours: calculatedHours,
        charge_cancellation_amount: chargeCancellationAmount,
      },
      ApiEndPoints.CHANGE_BOOKING_STATUS
    );
    if (result?.status === 200) {
      setLoading(false);
      toast.success(t(result.message));
      getReservationList();
    } else {
      setLoading(false);
      toast.error(t(result.message));
      getReservationList();
    }
  };

  const handleConfirmDeleteDuplicateReservationAction = async () => {
    setOpenConfirmDeleteDuplicateDialog(false);
    setLoading(true);

    const result = await deleteRecord(
      selectDetail?.id,
      ApiEndPoints.DELETE_BOOKING
    );
    if (result?.status === 200) {
      setLoading(false);
      toast.success(t(result.message));
      getReservationList();
    } else {
      setLoading(false);
      toast.error(t(result.message));
      getReservationList();
    }
  };
  // Pinpad Devices
  // const [pinpadDevicesList, setPinpadDevicesList] = useState([]);
  const [selectPinpadDevices, setSelectPinpadDevices] = useState("0");

  const handlePinpadDevice = (e) => {
    setSelectPinpadDevices(e.target.value);
  };
  useEffect(() => {
    // getPinpadDevicesDetail();
    if(otaCodeList?.length === 0){
      getOtaCodeList();
    }
  }, []);
  const getPinpadDevicesDetail = async () => {
    if(pinpadDevicesList?.length > 0){
      return;
    }
    const result = await fetchList(ApiEndPoints.GET_ALL_PINPAD_DEVICE);
    if (result?.status === 200) {
      pinpadDevicesListSuccess(result?.data);
    } else {
      pinpadDevicesListFailed([]);
    }
  };

  //Send SMS
  const [openSendSmsDialog, setOpenSendSmsDialog] = useState(false);
  const handleChangeSmsDialog = () => {
    setOpenSendSmsDialog(false);
    // setUser_id("");
  };

  // Add Payment
  const [openChangePaymentDialog, setOpenChangePaymentDialog] =
    React.useState(false);
  const [openMakePaymentDialog, setOpenMakePaymentDialog] = useState(false);
  const [showPaymentMessage, setShowPaymentMessage] = useState(false);

  const handleChangePaymentDialog = () => {
    setOpenChangePaymentDialog(false);
    setUser_id("");
    setCardDetail([]);
    setSelectDetail("");
    setPaymentType("");
  };
  const [paymentType, setPaymentType] = React.useState(2);
  const [user_id, setUser_id] = React.useState("");

  // change booking status
  const [bookingStatusValue, setBookingStatusValue] = useState(0);

  const [openChangeBookingStatus, setOpenChangeBookingStatus] = useState(false);
  const handleChangeBookingStatus = () => {
    setOpenChangeBookingStatus(false);
    setBookingStatusValue(0);
  };

  const [openConfirmSendSmsEmailDialog, setOpenConfirmSendSmsEmailDialog] =
    useState(false);

  const [
    openConfirmDeleteDuplicateDialog,
    setOpenConfirmDeleteDuplicateDialog,
  ] = useState(false);

  const [openFixTaxDialog, setOpenFixTaxDialog] = useState(false);
  const [handleValues, setHandleValues] = useState(0);

  const handleCloseFixTaxDialog = () => {
    setOpenFixTaxDialog(false);
    getReservationList();
  }

  const [chargeCancellationAmount, setChargeCancellationAmount] = useState(1);

  const handleConfirmOpenSmsEmail = (values) => {
    setHandleValues(values);
    setOpenConfirmSendSmsEmailDialog(true);
  };

  const handleNoSendSms = () => {
    if (handleValues === 1) {
      handleConfirmBookingStatus(0);
    }
    if (handleValues === 2) {
      handleConfirmCancelReservationAction(0);
    }
    if (handleValues === 3) {
      handleConfirmNoShowReservationAction(0);
    }
  };

  const handleYesSendSms = () => {
    if (handleValues === 1) {
      handleConfirmBookingStatus(1);
    }
    if (handleValues === 2) {
      handleConfirmCancelReservationAction(1);
    }
    if (handleValues === 3) {
      handleConfirmNoShowReservationAction(1);
    }
  };

  const handleConfirmBookingStatus = async (send_sms) => {
    setOpenConfirmSendSmsEmailDialog(false);

    getLoadingSuccess();
    let payload = {
      booking_id: reservationStatus?.booking_id,
      booking_status: bookingStatusValue,
      send_sms: send_sms,
    };
    const result = await createRecord(
      payload,
      ApiEndPoints.CHANGE_BOOKING_STATUS
    );
    if (result?.status === 200) {
      getLoadingFailed();
      toast.success(t(result.message));
      getReservationList();
      handleChangeBookingStatus();
    } else {
      getLoadingFailed();
      toast.error(t(result.message));
      // getReservationList();
    }
  };

  // change Payment Type

  const [openChangePaymentTypeDialog, setOpenChangePaymentTypeDialog] =
    React.useState(false);

  const handleChangePaymentTypeDialog = () => {
    setOpenChangePaymentTypeDialog(false);
    setUser_id("");
    setCardDetail([]);
    setSelectDetail("");
    setPaymentType("");
  };

  const handlePaymentTypeSubmit = async () => {
    getLoadingSuccess();
    let payload = {
      booking_id: reservationStatus?.booking_id,
      payment_type: paymentType,
      token: verifyToken,
      credit_card_id:
        (card_present === true && paymentType === 2) || paymentType === 1
          ? "0"
          : card?.id,
      device_id: selectPinpadDevices,
      card_present: card_present === true ? 1 : 0,
    };
    const result = await updateCardRecord(
      payload,
      ApiEndPoints.UPDATE_PAYMENT_TYPE
    );

    if (result?.status === 200) {
      getLoadingFailed();
      toast.success(t("Payment Type Successfully Changed"));
      getReservationList();
      handleChangePaymentTypeDialog();
    } else {
      getLoadingFailed();
      toast.error(t(result.message));
    }
  };

  const [smsUserDetail, setSmsUserDetail] = useState([]);

  // console.log(selectDetail?.id, 288, "id")
  const [smsInitialValue, setSmsInitialValue] = useState({
    phone_number: null,
    sms: "",
    phone_code: "+1",
  });

  // console.log(421, paymentType);

  const [emailInitialValue, setEmailInitialValue] = useState({
    email: "",
    body: "",
    subject: "",
  });
  const [cardDetail, setCardDetail] = React.useState([
    {
      id: "",
      user_id: "",
      card_holder_name: "",
      card_number: "",
      expiry_date: "",
      cvv: "",
      card_type: "",
    },
  ]);
  const [card, setCard] = React.useState({
    id: 0,
    user_id: "",
    card_holder_name: "",
    card_number: "",
    yyy: "",
    mm: "",
    cvv: "",
  });
  const [card_present, setCard_present] = useState(false);
  const [verifyToken, setVerifyToken] = React.useState("");

  const handalepaymentType = (e) => {
    setPaymentType(e.target.value);
  };

  const handaleCardPresent = (e) => {
    setCard_present(e.target.checked);
    setCard({
      id: 0,
      user_id: "",
      card_holder_name: "",
      card_number: "",
      yyy: "",
      mm: "",
      cvv: "",
    });
  };

  const setCradsDetail = (e) => {
    setVerifyToken("");
    if (e.target.value === 0) {
      setCard({
        id: 0,
        user_id: "",
        card_holder_name: "",
        card_number: "",
        yyy: "",
        mm: "",
        cvv: "",
        card_type: "",
      });
    } else {
      const data = cardDetail.find((item) => item.id === e.target.value);
      // console.log(data,493)
      setCard({
        id: Number.parseInt(data?.id),
        user_id: data?.user_id,
        card_holder_name: data?.card_holder_name,
        card_number: data?.card_number,
        yyy: data?.expiry_date.split("-")[0],
        mm: data?.expiry_date.split("-")[1],
        cvv: data?.cvv,
        card_type: data?.card_type,
      });
      setVerifyToken(data?.token);
    }
  };

  const handeleCardChange = (e) => {
    setVerifyToken("");
    setCard({ ...card, [e.target.name]: e.target.value });
  };

  // console.log(card,548)

  useEffect(() => {
    if (paymentType == 2) {
      if (user_id) {
        getCradsDetail(user_id);
      }
    }
  }, [user_id]);

  const getCradsDetail = async (Id) => {
    const user_ids = user_id;
    const result = await getRecord(
      Id || user_ids,
      ApiEndPoints.GET_USER_CARD_DETAIL
    );
    const cardLists = [];
    if (result?.status === 200) {
      for (let j in result.data) {
        cardLists.push({
          id: result.data[j].id,
          user_id: result.data[j].user_id,
          card_holder_name: result.data[j].card_holder_name,
          card_number: result.data[j].card_number,
          expiry_date: result.data[j].expiry_date,
          cvv: result.data[j].cvv,
          card_type: result?.data[j]?.card_type,
        });
      }
      setCardDetail(cardLists);
    } else {
      setCardDetail([]);
    }
  };

  const handleSendEmail = async (Value) => {
    getLoadingSuccess();
    // console.log(Value,505);
    const result = await sendEmail(Value, ApiEndPoints.SEND_EMAIL);

    if (result?.status === 200) {
      getLoadingFailed();
      toast.success(t("Mail Sent Successfully"));
    } else {
      getLoadingFailed();
      toast.error(t(result.message));
    }
  };

  const handleSendSms = async (Value) => {
    getLoadingSuccess();
    // console.log(Value,498);
    const result = await sendSms(Value, ApiEndPoints.SEND_SMS);

    if (result?.status === 200) {
      getLoadingFailed();
      toast.success(t("Message Sent Successfully"));
    } else {
      getLoadingFailed();
      toast.error(t(result.message));
    }
  };

  const handleSendAgreement = async () => {
    getLoadingSuccess();

    // selectDetail?.id
    const result = await sendEmail(
      { bookingId: selectDetail?.id },
      ApiEndPoints.SEND_AGREMENT
    );

    if (result?.status === 200) {
      getLoadingFailed();
      toast.success(t("Agreement Sms Sent Successfully"));
    } else {
      getLoadingFailed();
      toast.error(t(result.message));
    }
  };

  const handleSendAgreementEmail = async () => {
    getLoadingSuccess();

    // selectDetail?.id
    const result = await sendEmail(
      { bookingId: selectDetail?.id },
      ApiEndPoints.SEND_AGREMENT_EMAIL
    );

    if (result?.status === 200) {
      getLoadingFailed();
      toast.success(t("Agreement Email Sent Successfully"));
    } else {
      getLoadingFailed();
      toast.error(t(result.message));
    }
  };

  const handleSendFolioReceipt = async () => {
    getLoadingFailed();

    // selectDetail?.id
    const result = await sendEmail(
      { bookingId: selectDetail?.id },
      ApiEndPoints.SEND_FOLIO_RECEIPT
    );

    if (result?.status === 200) {
      getLoadingFailed();
      toast.success(t("Folio Receipt Sms Sent Successfully"));
    } else {
      getLoadingFailed();
      toast.error(t(result.message));
    }
  };

  const handleSendFolioReceiptEmail = async () => {
    getLoadingSuccess();

    // selectDetail?.id
    const result = await sendEmail(
      { bookingId: selectDetail?.id },
      ApiEndPoints.SEND_FOLIO_RECEIPT_EMAIL
    );

    if (result?.status === 200) {
      getLoadingFailed();
      toast.success(t("Folio Receipt Email Sent Successfully"));
    } else {
      getLoadingFailed();
      toast.error(t(result.message));
    }
  };

  const addCardDetail = async () => {
     if (
          card?.card_holder_name === "" ||
          card?.yyy === "" ||
          card?.card_number === "" ||
          card?.mm === ""
        ) {
          toast.error("You Must Add Card Detail");
          return;
        }
        if(card?.card_number?.length < 8){
          toast.error("Please, enter valid card number");
          return;
        }

    const name = card?.card_holder_name.trim().split(/\s+/);
    const expiry_date = card?.yyy.split("");

    const bodyFormData = {
      user_id: user_id,
      card_number: cryptoEncryptData(Number.parseInt(card?.card_number)?.toString()),
      expiry_date: cryptoEncryptData(
        (
          `${card?.mm}${expiry_date.at(-2)}${
            expiry_date.at(-1)
          }`
        )?.toString()
      ),
      first_name: name[0],
      last_name: name[1] ? name[1] : "",
      security_code: cryptoEncryptData(card?.cvv?.toString()),
    };

    // console.log(card, bodyFormData, 741);
    getLoadingSuccess();

    const result = await VerifyCard(bodyFormData, card);
    if (result?.status === 200) {
        getLoadingFailed();
        const bodyFormData = result?.bodyFormData;
        setVerifyToken(bodyFormData?.token);
        getCradsDetail(user_id);
       
        const results = await createRecord(
          bodyFormData,
          ApiEndPoints.ADD_USER_CARD_DETAIL
        );
        if (results?.status === 200) {
          toast.success(results.message);
          if (cardDetail?.length === 0) {
            const resultPrimary = await updateCardRecord(
              {
                booking_id: reservationStatus?.booking_id,
                card_id: Number.parseInt(results?.data?.id),
              },
              ApiEndPoints.CHANGE_PRIMARY_CARD
            );
            if (resultPrimary.status == 200) {
              toast.success(t("Primary Card Updated Successfully"));
            }
          }
          getCradsDetail(user_id);

          setCard({
            id: Number.parseInt(results?.data?.id),
            user_id: results?.data?.user_id,
            card_holder_name: results?.data?.card_holder_name,
            card_number: results?.data?.card_number,
            yyy: results?.data?.expiry_date.split("-")[0],
            mm: results?.data?.expiry_date.split("-")[1],
            cvv: results?.data?.cvv,
            card_type: results?.data?.card_type,
          });
          setVerifyToken(results?.data?.token);
          getLoadingFailed();
        } else {
          getLoadingFailed();
          toast.error(results.message);
        }
    }  else {
      setVerifyToken("");
      getLoadingFailed();
    }
    // CardDetailVerify();
  };



  // refund Transection
  const [refundAmount, setRefundAmount] = React.useState("");
  const [openRefundDialog, setOpenRefundDialog] = React.useState(false);
  const handleRefundDialog = () => setOpenRefundDialog(false);

  const handleConfirmRefundAction = async () => {
    if (refundAmount == "") {
      toast.error(t("Please Add Amount"));
      return;
    }
    setLoading(true);
    const data = {
      booking_id: reservationStatus?.booking_id,
      amount: refundAmount,
    };
    const result = await createRecord(data, ApiEndPoints.REFUND_TRANSACTION);
    if (result?.status === 200) {
      setLoading(false);
      toast.success(t(result.message));
      getReservationList();
      setRefundAmount("");
      setOpenRefundDialog(false);
    }  else {
      setLoading(false);
      toast.error(t(result.message));
    }
  };

  // Void Transection
  const [openVoidDialog, setOpenVoidDialog] = React.useState(false);
  const handleVoidDialog = () => setOpenVoidDialog(false);
  const handleConfirmVoidAction = async () => {
    setLoading(true);
    const result = await getRecord(
      reservationStatus?.booking_id,
      ApiEndPoints.VOID_TRANSACTION
    );
    if (result?.status === 200) {
      setLoading(false);
      toast.success(t(result.message));
      getReservationList();
      setOpenVoidDialog(false);
    } else {
      setLoading(false);
      toast.error(t(result.message));
    }
  };

  // add Remark

  const [openRemarkDialog, setOpenRemarkDialog] = useState(false);
  const [remarkValue, setRemarkValue] = useState("");
  const handleCloseRemarkDialog = () => {
    setOpenRemarkDialog(false);
    setRemarkValue("");
  };

  const handleConfirmRemarkAction = async () => {
    setLoading(true);
    let payload = {
      booking_id: reservationStatus?.booking_id,
      remark: remarkValue,
    };
    const result = await createRecord(payload, ApiEndPoints.ADD_REMARK);
    if (result?.status === 200) {
      setLoading(false);
      toast.success(t(result.message));
      handleCloseRemarkDialog();
    } else if (result === undefined) {
      setLoading(false);
      toast.error(t(result.message));
    } else {
      setLoading(false);
      toast.error(t(result.message));
      getReservationList();
    }
  };

  const [openNoShowReservationDialog, setOpenNoShowReservationDialog] =
    React.useState(false);
  const handleCloseNoShowReservationDialog = () =>
    setOpenNoShowReservationDialog(false);

  const handleConfirmNoShowReservationAction = async (send_sms) => {
    setOpenConfirmSendSmsEmailDialog(false);
    setLoading(true);
    setOpenNoShowReservationDialog(false);
    const result = await createRecord(
      { ...reservationStatus, send_sms: send_sms },
      ApiEndPoints.CHANGE_BOOKING_STATUS
    );
    if (result?.status === 200) {
      setLoading(false);
      toast.success(t(result.message));
      getReservationList();
    } else if (result === undefined) {
      setLoading(false);
      toast.error(t(result.message));
    } else {
      setLoading(false);
      toast.error(t(result.message));
      getReservationList();
    }
  };

  const datagridColumns = [
    {
      field: "id",
      headerName: t("Confirmation#"),
      flex: 1,
      renderCell: (params) => (
        <>
          {params.value ? (
            <Link
              to={`/reservation/bookingDetail/${cryptoEncryptData(
                params.row.booking_id.toString()
              )}`}
            >
              {params.value}
            </Link>
          ) : null}
        </>
      ),
    },
    { field: "name", headerName: t("Guests"), flex: 1 },
    // { field: "no_of_days", headerName: t("Nights"), flex: 0.5 },
    {
      field: "booking_status",
      headerName: t("Status"),
      flex: 1,
      // renderCell: (params) => t(params?.row?.booking_status),
    },
    { field: "booking_date", headerName: t("Booking Date"), flex: 1 },
    { field: "checkin_date", headerName: t("Check In"), flex: 1 },
    { field: "checkout_date", headerName: t("Check Out"), flex: 1 },
    { field: "room_type", headerName: t("Room Type"), flex: 1 },
    {
      field: "booking_type",
      headerName: t("Booking Type"),
      flex: 1,
      renderCell: (params) => t(params?.row?.booking_type),
    },
    {
      field: "bookingSource",
      headerName: t("Booking Source"),
      flex: 1,
      renderCell: (params) => t(params?.row?.bookingSource),
    },
    { field: "final_amount", headerName: t("Amount"), flex: 0.9 },
    //{ field: "final_amount", headerName: "Balance", flex: 1 },
    // {
    //   field: "actions",
    //   type: "actions",
    //   headerName: "Action",
    //   flex: 1,
    //   getActions: (params) => [
    //     <GridActionsCellItem
    //       label="View Sales"
    //       // onClick={viewsales(params)}
    //       showInMenu
    //     />,
    //   ],
    // },
    {
      field: "chat",
      headerName: t("Chat"),
      flex: 0.5,
      renderCell: (params) => (
        <div
          style={{ display: "flex", justifyContent: "start", width: "100%" }}
        >
          <PiChatCircleDotsDuotone
            size={20}
            style={{ cursor: "pointer" }}
            onClick={(e) => {
              localStorage.setItem(
                "receiver_user",
                JSON.stringify(
                  +params?.row?.secondary_user_id === 0
                    ? params?.row?.user_id
                    : params?.row?.secondary_user_id
                )
              );
              navigate("/chat");
            }}
          />
        </div>
      ),
    },
    {
      field: "actions",
      type: "actions",
      headerName: t("Actions"),
      flex: 0.7,
      getActions: (params) => {      
        const actions =
          params.row.booking_status_id === 2 &&
          +params.row?.bookingSourceId !== 3
            ? [
                getPermissionList("Reservation", 3)?.hasPermission && (
                <GridActionsCellItem
                  label={t("Check In")}
                  onClick={() => {
                    handleEdit(params.row.booking_id, 1);
                    // handleDialogOpen();
                  }}
                  showInMenu
                />),
                getPermissionList("Reservation", 4)?.hasPermission && (
                <GridActionsCellItem
                  label={t("Cancel")}
                  onClick={() => {
                    handleBookingStatus(params, 1);
                  }}
                  showInMenu
                />
                ),
                getPermissionList("Reservation", 3)?.hasPermission && (
                <GridActionsCellItem
                  label={t("No Show")}
                  onClick={() => {
                    handleBookingStatus(params, 2);
                  }}
                  showInMenu
                />),
                getPermissionList("Reservation", 3)?.hasPermission && (
                <GridActionsCellItem
                  label={t("Edit")}
                  onClick={() => {
                    navigate(
                      `/reservation/edit/${cryptoEncryptData(
                        (params?.row?.booking_id).toString()
                      )}`
                    );
                  }}
                  showInMenu
                />),
                getPermissionList("Reservation", 3)?.hasPermission && (
                <GridActionsCellItem
                  label={t("Add Payment")}
                  onClick={() => {
                    handleBookingStatus(params, 5);
                  }}
                  showInMenu
                />),
                getPermissionList("Reservation", 3)?.hasPermission && (
                <GridActionsCellItem
                  label={t("Change Payment Type")}
                  onClick={() => {
                    handleBookingStatus(params, 7);
                  }}
                  showInMenu
                />),
                getPermissionList("Reservation", 3)?.hasPermission && (
                <GridActionsCellItem
                  label={t("Send SMS/Email")}
                  onClick={() => handleBookingStatus(params, 6)}
                  showInMenu
                />),
                getPermissionList("Reservation", 3)?.hasPermission && (
                <GridActionsCellItem
                  label={t("Add Remark")}
                  onClick={() => handleBookingStatus(params, 9)}
                  showInMenu
                />),

                // params.row?.userBookingCount > 1 ? (
                  <GridActionsCellItem
                    label={t("User's All Bookings")}
                    onClick={() => {
                      setSearchFilters({
                        ...searchFilters,
                        startDate: moment()
                          .subtract(2, "years")
                          .format("YYYY-MM-DD"),
                        endDate: moment().add(2, "years").format("YYYY-MM-DD"),
                      });
                      navigate(`/reservation?user_id=${params?.row?.user_id}`);
                    }}
                    showInMenu
                  />,
                // ) : null,
                getPermissionList("Reservation", 4)?.hasPermission && (
                <GridActionsCellItem
                  label={t("Delete Booking")}
                  onClick={() => handleBookingStatus(params, 10)}
                  showInMenu
                />),
                // <GridActionsCellItem
                //   label={t("Update Tax")}
                //   onClick={() => handleEdit(params.row.booking_id, 3)}
                //   showInMenu
                // />,
              ]
            : params.row.booking_status_id === 2 &&
              +params.row?.bookingSourceId === 3
            ? [
                getPermissionList("Reservation", 3)?.hasPermission && (

                <GridActionsCellItem
                  label={t("Check In")}
                  onClick={() => {
                    handleEdit(params.row.booking_id, 1);
                    // handleDialogOpen();
                  }}
                  showInMenu
                />),
                getPermissionList("Reservation", 3)?.hasPermission && (
                <GridActionsCellItem
                  label={t("No Show")}
                  onClick={() => {
                    handleBookingStatus(params, 2);
                  }}
                  showInMenu
                />),
                // <GridActionsCellItem
                //   label={t("Edit")}
                //   onClick={() => {
                //     navigate(`/reservation/edit/${params?.row?.booking_id}`);
                //   }}
                //   showInMenu
                // />,
                getPermissionList("Reservation", 3)?.hasPermission && (
                <GridActionsCellItem
                  label={t("Add Payment")}
                  onClick={() => {
                    handleBookingStatus(params, 5);
                  }}
                  showInMenu
                />),
                getPermissionList("Reservation", 3)?.hasPermission && (
                <GridActionsCellItem
                  label={t("Change Payment Type")}
                  onClick={() => {
                    handleBookingStatus(params, 7);
                  }}
                  showInMenu
                />),
                getPermissionList("Reservation", 3)?.hasPermission && (
                <GridActionsCellItem
                  label={t("Send SMS/Email")}
                  onClick={() => handleBookingStatus(params, 6)}
                  showInMenu
                />),
                getPermissionList("Reservation", 3)?.hasPermission && (
                <GridActionsCellItem
                  label={t("Add Remark")}
                  onClick={() => handleBookingStatus(params, 9)}
                  showInMenu
                />),

                // params.row?.userBookingCount > 1 ? (
                  <GridActionsCellItem
                    label={t("User's All Bookings")}
                    onClick={() => {
                      setSearchFilters({
                        ...searchFilters,
                        startDate: moment()
                          .subtract(2, "years")
                          .format("YYYY-MM-DD"),
                        endDate: moment().add(2, "years").format("YYYY-MM-DD"),
                      });
                      navigate(`/reservation?user_id=${params?.row?.user_id}`);
                    }}
                    showInMenu
                  />,
                // ) : null,
                getPermissionList("Reservation", 4)?.hasPermission && (
                <GridActionsCellItem
                  label={t("Delete Booking")}
                  onClick={() => handleBookingStatus(params, 10)}
                  showInMenu
                />),
              ]
            : params.row.booking_status_id === 3 &&
              +params.row?.bookingSourceId !== 3
            ? //&& params.row.checkin_date < moment(new Date()).format("MM/DD/YYYY")
              [
                getPermissionList("Reservation", 3)?.hasPermission && (
                <GridActionsCellItem
                  label={t("Check Out")}
                  onClick={() => {
                    handleEdit(params.row.booking_id, 2);
                  }}
                  showInMenu
                />),

                // <GridActionsCellItem
                //   label={t("Change Payment Type")}
                //   onClick={() => {
                //     handleBookingStatus(params, 7);
                //   }}
                //   showInMenu
                // />,
                getPermissionList("Reservation", 3)?.hasPermission && (

                <GridActionsCellItem
                  label={t("Change Status")}
                  onClick={() => {
                    handleBookingStatus(params, 8);
                  }}
                  showInMenu
                />
                ),
                <GridActionsCellItem
                  label={t("View Folio")}
                  onClick={() => {
                    navigate(
                      `/reservation/folioDetail/${cryptoEncryptData(
                        params.row.booking_id.toString()
                      )}`
                    );
                  }}
                  showInMenu
                />,
                getPermissionList("Reservation", 3)?.hasPermission && (
                <GridActionsCellItem
                  label={t("Edit")}
                  onClick={() => {
                    navigate(
                      `/reservation/edit/${cryptoEncryptData(
                        (params?.row?.booking_id).toString()
                      )}`
                    );
                  }}
                  showInMenu
                />),
                getPermissionList("Reservation", 3)?.hasPermission && (
                <GridActionsCellItem
                  label={t("Send SMS/Email")}
                  onClick={() => handleBookingStatus(params, 6)}
                  showInMenu
                />),
                getPermissionList("Reservation", 3)?.hasPermission && (
                <GridActionsCellItem
                  label={t("Add Payment")}
                  onClick={() => {
                    handleBookingStatus(params, 5);
                  }}
                  showInMenu
                />),
                getPermissionList("Reservation", 3)?.hasPermission && (
                <GridActionsCellItem
                  label={t("Add Remark")}
                  onClick={() => handleBookingStatus(params, 9)}
                  showInMenu
                />),
                // <GridActionsCellItem
                //   label={t("Void Transactio")}
                //   onClick={() => {
                //     handleBookingStatus(params, 3);
                //   }}
                //   showInMenu
                // />,
                // params.row?.userBookingCount > 1 ? (
                  <GridActionsCellItem
                    label={t("User's All Bookings")}
                    onClick={() => {
                      setSearchFilters({
                        ...searchFilters,
                        startDate: moment()
                          .subtract(2, "years")
                          .format("YYYY-MM-DD"),
                        endDate: moment().add(2, "years").format("YYYY-MM-DD"),
                      });
                      navigate(`/reservation?user_id=${params?.row?.user_id}`);
                    }}
                    showInMenu
                  />,
                // ) : null,
                 getPermissionList("Reservation", 4)?.hasPermission && (

                <GridActionsCellItem
                  label={t("Delete Booking")}
                  onClick={() => handleBookingStatus(params, 10)}
                  showInMenu
                />),
                // <GridActionsCellItem
                //   label={t("Change Payment Type")}
                //   onClick={() => {
                //     handleBookingStatus(params, 7);
                //   }}
                //   showInMenu
                // />,
              ]
            : params.row.booking_status_id === 3 &&
              +params.row?.bookingSourceId === 3
            ? //&& params.row.checkin_date < moment(new Date()).format("MM/DD/YYYY")
              [
              getPermissionList("Reservation", 3)?.hasPermission && (
                <GridActionsCellItem
                  label={t("Check Out")}
                  onClick={() => {
                    handleEdit(params.row.booking_id, 2);
                  }}
                  showInMenu
                />),

                // <GridActionsCellItem
                //   label={t("Change Payment Type")}
                //   onClick={() => {
                //     handleBookingStatus(params, 7);
                //   }}
                //   showInMenu
                // />,
              getPermissionList("Reservation", 3)?.hasPermission && (
                <GridActionsCellItem
                  label={t("Change Status")}
                  onClick={() => {
                    handleBookingStatus(params, 8);
                  }}
                  showInMenu
                />),
                <GridActionsCellItem
                  label={t("View Folio")}
                  onClick={() => {
                    navigate(
                      `/reservation/folioDetail/${cryptoEncryptData(
                        params.row.booking_id.toString()
                      )}`
                    );
                  }}
                  showInMenu
                />,
                getPermissionList("Reservation", 3)?.hasPermission && (
                <GridActionsCellItem
                  label={t("Send SMS/Email")}
                  onClick={() => handleBookingStatus(params, 6)}
                  showInMenu
                />),
                // <GridActionsCellItem
                //   label={t("Void Transactio")}
                //   onClick={() => {
                //     handleBookingStatus(params, 3);
                //   }}
                //   showInMenu
                // />,
              getPermissionList("Reservation", 3)?.hasPermission && (
                <GridActionsCellItem
                  label={t("Add Payment")}
                  onClick={() => {
                    handleBookingStatus(params, 5);
                  }}
                  showInMenu
                />),
                getPermissionList("Reservation", 3)?.hasPermission && (
                <GridActionsCellItem
                  label={t("Add Remark")}
                  onClick={() => handleBookingStatus(params, 9)}
                  showInMenu
                />),
                // params.row?.userBookingCount > 1 ? (
                  <GridActionsCellItem
                    label={t("User's All Bookings")}
                    onClick={() => {
                      setSearchFilters({
                        ...searchFilters,
                        startDate: moment()
                          .subtract(2, "years")
                          .format("YYYY-MM-DD"),
                        endDate: moment().add(2, "years").format("YYYY-MM-DD"),
                      });
                      navigate(`/reservation?user_id=${params?.row?.user_id}`);
                    }}
                    showInMenu
                  />,
                // ) : null,
              getPermissionList("Reservation", 4)?.hasPermission && (
                <GridActionsCellItem
                  label={t("Delete Booking")}
                  onClick={() => handleBookingStatus(params, 10)}
                  showInMenu
                />),
                // <GridActionsCellItem
                //   label={t("Change Payment Type")}
                //   onClick={() => {
                //     handleBookingStatus(params, 7);
                //   }}
                //   showInMenu
                // />,
              ]
            : params.row.booking_status_id === 4
            ? [
                <GridActionsCellItem
                  label={t("View Folio")}
                  onClick={() => {
                    navigate(
                      `/reservation/folioDetail/${cryptoEncryptData(
                        params.row.booking_id.toString()
                      )}`
                    );
                  }}
                  showInMenu
                />,
                getPermissionList("Reservation", 4)?.hasPermission && (
                <GridActionsCellItem
                label={t("Cancel")}
                onClick={() => {
                  handleBookingStatus(params, 1);
                }}
                showInMenu
              />
                ),
              getPermissionList("Reservation", 3)?.hasPermission && (
                <GridActionsCellItem
                  label={t("Send SMS/Email")}
                  onClick={() => handleBookingStatus(params, 6)}
                  showInMenu
                />),
                getPermissionList("Reservation", 3)?.hasPermission && (
                <GridActionsCellItem
                  label={t("Add Remark")}
                  onClick={() => handleBookingStatus(params, 9)}
                  showInMenu
                />),
                // params.row?.userBookingCount > 1 ? (
                  <GridActionsCellItem
                    label={t("User's All Bookings")}
                    onClick={() => {
                      setSearchFilters({
                        ...searchFilters,
                        startDate: moment()
                          .subtract(2, "years")
                          .format("YYYY-MM-DD"),
                        endDate: moment().add(2, "years").format("YYYY-MM-DD"),
                      });
                      navigate(`/reservation?user_id=${params?.row?.user_id}`);
                    }}
                    showInMenu
                  />,
                // ) : null,
                //         <GridActionsCellItem
                //           label={t("Generate Invoice")}
                //           onClick={() => {
                // window.open(`/create-invoice/${params?.row?.booking_id}?sms_send=1`, '_blank', 'noopener,noreferrer');

                //           }}
                //           showInMenu
                //         />,
              ]
            : (+params.row?.bookingSourceId !== 3) ? [
                <GridActionsCellItem
                  label={t("View Folio")}
                  onClick={() => {
                    navigate(
                      `/reservation/folioDetail/${cryptoEncryptData(
                        params.row.booking_id.toString()
                      )}`
                    );
                  }}
                  showInMenu
                />,
                getPermissionList("Reservation", 3)?.hasPermission && (
                <GridActionsCellItem
                label={t("Change Status")}
                onClick={() => {
                  handleBookingStatus(params, 8);
                }}
                showInMenu
              />),
                getPermissionList("Reservation", 3)?.hasPermission && (
                <GridActionsCellItem
                  label={t("Send SMS/Email")}
                  onClick={() => handleBookingStatus(params, 6)}
                  showInMenu
                />),
                getPermissionList("Reservation", 3)?.hasPermission && (
                <GridActionsCellItem
                  label={t("Add Remark")}
                  onClick={() => handleBookingStatus(params, 9)}
                  showInMenu
                />),
                // params.row?.userBookingCount > 1 ? (
                  <GridActionsCellItem
                    label={t("User's All Bookings")}
                    onClick={() => {
                      setSearchFilters({
                        ...searchFilters,
                        startDate: moment()
                          .subtract(2, "years")
                          .format("YYYY-MM-DD"),
                        endDate: moment().add(2, "years").format("YYYY-MM-DD"),
                      });
                      navigate(`/reservation?user_id=${params?.row?.user_id}`);
                    }}
                    showInMenu
                  />,
                // ) : null,
              ]: [
                <GridActionsCellItem
                  label={t("View Folio")}
                  onClick={() => {
                    navigate(
                      `/reservation/folioDetail/${cryptoEncryptData(
                        params.row.booking_id.toString()
                      )}`
                    );
                  }}
                  showInMenu
                />,
                getPermissionList("Reservation", 3)?.hasPermission && (
                <GridActionsCellItem
                  label={t("Send SMS/Email")}
                  onClick={() => handleBookingStatus(params, 6)}
                  showInMenu
                />),
                getPermissionList("Reservation", 3)?.hasPermission && (
                <GridActionsCellItem
                  label={t("Add Remark")}
                  onClick={() => handleBookingStatus(params, 9)}
                  showInMenu
                />),
                // params.row?.userBookingCount > 1 ? (
                  <GridActionsCellItem
                    label={t("User's All Bookings")}
                    onClick={() => {
                      setSearchFilters({
                        ...searchFilters,
                        startDate: moment()
                          .subtract(2, "years")
                          .format("YYYY-MM-DD"),
                        endDate: moment().add(2, "years").format("YYYY-MM-DD"),
                      });
                      navigate(`/reservation?user_id=${params?.row?.user_id}`);
                    }}
                    showInMenu
                  />,
                // ) : null,
              ];

        const validActions = actions.filter(
          (action) => !(action === undefined || action === null)
        );
        return validActions;
      },
    },
  ];

  const [tab, setTab] = useState(0);

  const handleTabs = (num) => {
    setTab(num);
  };

  const handleDialogOpen = () => setOpenDialog(true);
  const handleDialogClose = () => {
    setOpenDialog(false);
    getReservationList();
  };

  const handleDialogOutOpen = () => setOpenDialogout(true);
  const handleDialogOutClose = () => {
    setOpenDialogout(false);
    getReservationList();
  };

  // const handleCloseEditDialog = () => {
  //   setOpenEditDialog(false);
  //   getReservationList();
  // };

  const bookingStatus = [
    {
      id: 1,
      name: t("Pending"),
    },
    {
      id: 2,
      name: t("Confirmed"),
    },
    {
      id: 3,
      name: t("In House"),
    },
    {
      id: 4,
      name: t("Checked-out"),
    },
    {
      id: 5,
      name: t("Cancelled"),
    },
    {
      id: 6,
      name: t("No Show"),
    },
  ];

  const bookingTypeList = [
    {
      id: 1,
      name: t("Corporate"),
    },
    {
      id: 2,
      name: t("Non-Corporate"),
    },
  ];
  const paymentTypeList = [
    {
      id: 1,
      name: t("Cash"),
    },
    {
      id: 2,
      name: t("Credit Card"),
    },
    {
      id: 3,
      name: t("Cheque"),
    },
    {
      id: 4,
      name: t("Direct Bill"),
    },
  ];

  const bookingSource = [
    {
      id: 1,
      name: t("Admin"),
    },
    {
      id: 2,
      name: t("App"),
    },
    {
      id: 3,
      name: t("OTA"),
    },
    {
      id: 4,
      name: t("Web"),
    },
  ];

  // const [otaCodeList, setOtaCodeList] = useState([]);

  const getOtaCodeList = async () => {
    // setLoadingOta(true);
    if (otaCodeList?.length === 0) {
      const result = await fetchList(ApiEndPoints.OTA_LIST_FOR_SELECT);
      if (result?.status === 200) {
        let arry = result?.data?.map((item) => ({
          name: item?.ota_name,
          value: item?.ota_code,
        }));

        // setOtaCodeList(arry);
        otaCodeListSuccess(arry)
        // setLoadingOta(false);
      } else {
        console.log(result.message + ", please check!");
        // setOtaCodeList([]);
        otaCodeListFailed();
        // setLoadingOta(false);
      }
    }
  };

  const handleSearch = (event) => {
    const { value } = event.target;
    if (value.length > 1 || value.length == 0) {
      setSearchFilters({ ...searchFilters, search_text: value });
      updateReservationList("page", 1);
      handleTriggerLoadingFailed();

    }
  };

  const handleBoookingStatusChange = (event) => {
    const { value } = event.target;
      setSearchFilters({
        ...searchFilters,
        booking_status: value,
      });
    updateReservationList("page", 1);
    handleTriggerLoadingFailed();
  };

  const handleBoookingTypeChange = (event) => {
    const { value } = event.target;
    setSearchFilters({
      ...searchFilters,
      booking_type: value,
    });
    updateReservationList("page", 1);
    handleTriggerLoadingFailed();
  };

  const handlePaymentTypeChange = (event) => {
    const { value } = event.target;
    setSearchFilters({
      ...searchFilters,
      payment_type: value,
    });
    updateReservationList("page", 1);
    handleTriggerLoadingFailed();
  };

  const handleBoookingSourceChange = (event) => {
    const { value } = event.target;
      setSearchFilters({
        ...searchFilters,
        booking_source: value,
      });
    updateReservationList("page", 1);
    handleTriggerLoadingFailed();
  };

  const handleBoookingOtaSourceChange = (event) => {
    const { value } = event.target;

    setSearchFilters({
      ...searchFilters,
      ota_source: value,
    });
    updateReservationList("page", 1);
    handleTriggerLoadingFailed();

  };

  // console.log(pinpadDevicesList,936);
  // console.log(1)
  // console.log(datagridPrintOptions, 2049);
  return (
    <div className="main-layout-background h-100vh w-100">
      {(loading) && <Loader />}
      <div style={{ position: "absolute", right: "13000px", display: "none" }}>
        {/* <PrintableArrivalReport
                datagridOptions={datagridOptions}
                datagridColumns={datagridColumns}
                ref={componentRef}
              /> */}
        <ReservationPrint
          datagridOptions={datagridPrintOptions}
          datagridColumns={datagridColumns}
          name={
            "Reservation List - " +
            searchFilters?.startDate +
            " to " +
            searchFilters?.endDate
          }
          ref={componentRef}
        />
      </div>
      <div className="d-flex mb-2 justify-content-between align-items-end  mt-2rem">
        <div className="d-flex mt-2rem">
          <h1 className="pagename-heading">{t("Reservations")}</h1>
          <p className="mt-1">
            {t("Home")} / {tab === 0 ? t("Reservations") : "Groups"}
          </p>
        </div>
        <div
          className="pr-3"
          style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}
        >
          <Button
            size="large"
            variant="contained"
            disableElevation
            color="primary"
            // onClick={() =>
            //   ExportToExelCompo({
            //     searchFilters,
            //     datagridPrintOptions,
            //     datagridColumns,
            //     name: "Reservation List",
            //     title: `Reservation List ${searchFilters?.startDate +
            //   " to " +
            //   searchFilters?.endDate}`,
            //   })
            // }
            onClick={() => {
              getReservationPrintList(1);
              // Resolve after fetching data
            }}
            className="ml-1 comman-button"
          >
            {t("Export")}{" "}
          </Button>
          <ReactToPrint
            trigger={() => (
              <Button
                size="large"
                variant="contained"
                disableElevation
                color="primary"
                className="comman-button"
              >
                {t("Print")}
              </Button>
            )}
            content={() => componentRef.current}
            onBeforeGetContent={async () => {
              // await getReservationPrintList(0); // Ensure this completes before printing
              return new Promise((resolve) => {
                promiseResolveRef.current = resolve;
                getReservationPrintList(0);
              });
            }}
            onAfterPrint={() => {
              // Reset the Promise resolve so we can print again
              promiseResolveRef.current = null;
              setIsPrinting(false);
            }}
            pageStyle={`
                    @page {
                      size: A4;
                      margin: 11mm 17mm 17mm 17mm;
                    }
      
                    @top-right-corner {
                      content: "Page " counter(page);
                      font-size: 18px; /* Increase pagination font size */
                      margin-top: -20px;
                    }   
                  `}
            documentTitle={
              "Reservation List -" +
              searchFilters?.startDate +
              " to " +
              searchFilters?.endDate
            }
          />
        </div>
      </div>
      <div className="nav-header justify-content-start">
        <div
          onClick={() => handleTabs(0)}
          className={`nav-tab text-16 ${tab == 0 ? "active-tab" : ""}`}
        >
          {t("Reservation")}
        </div>
        {/* <div
          onClick={() => handleTabs(1)}
          className={`nav-tabs ${tab == 1 ? "active-tab" : ""}`}
        >
          Groups
        </div> */}
      </div>
      <div className="pl-3 pr-3 mt-3">
        <Grid container spacing={1}>
          <Grid item lg={6} md={6} xs={12}>
            <FormControl fullWidth>
              <Stack direction="row" spacing={1} alignItems="center">
                <Typography
                  id="font-600"
                  style={{
                    marginBottom: "11px",
                    color: "rgb(30, 30, 30)",
                    fontSize: "16px",
                    lineHeight: "24px",
                    fontWeight: "500 !important",
                  }}
                >
                  {t("Search By Booking ID")}
                  {/* {+searchFilters?.search_in_booking === 1 ? " By Booking" : " By Name"} */}
                </Typography>
                <Switch
                  {...label}
                  checked={+searchFilters?.search_in_booking === 1}
                  onChange={(e) => {
                    setSearchFilters({
                      ...searchFilters,
                      search_in_booking: e.target.checked ? 1 : 0,
                    });
                    updateReservationList("page", 1);
                    handleTriggerLoadingFailed();
                  }}
                  sx={{ [`&.MuiSwitch-root`]: { marginTop: "-11px" } }}
                />
              </Stack>
              <TextField
                label={`${t("Search")} ${
                  +searchFilters?.search_in_booking === 1
                    ? t(" By Booking")
                    : t(" By User Name, Mobile.")
                }`}
                onChange={(event) => {
                  handleSearch(event);
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton>
                        <SearchIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </FormControl>
          </Grid>
          <Grid item lg={3} md={3} xs={6}>
            <FormControl fullWidth>
              <Typography
                id="font-600"
                style={{
                  marginBottom: "11px",
                  color: "rgb(30, 30, 30)",
                  fontSize: "16px",
                  lineHeight: "24px",
                  fontWeight: "500 !important",
                }}
              >
                {t("From Date")}
              </Typography>
              <DatePicker
                format="MM/DD/YYYY" // Ensures MM/DD/YYYY format
                value={moment(searchFilters.startDate, "YYYY-MM-DD")}
                onChange={(e) => {
                  setSearchFilters({
                    ...searchFilters,
                    startDate: moment(e).format("YYYY-MM-DD"),
                  });
                  updateReservationList("page", 1);
                  handleTriggerLoadingFailed();
                }}
                minDate={getMinDateForLimited()}
                slotProps={{
                  textField: {
                    readOnly: true,
                  },
                }}
              />
            </FormControl>
          </Grid>
          <Grid item md={3} xs={6}>
            <FormControl fullWidth>
              <Typography
                id="font-600"
                style={{
                  marginBottom: "11px",
                  color: "rgb(30, 30, 30)",
                  fontSize: "16px",
                  lineHeight: "24px",
                  fontWeight: "500 !important",
                }}
              >
                {t("End Date")}
              </Typography>
              <DatePicker
                format="MM/DD/YYYY" // Ensures MM/DD/YYYY format
                minDate={moment(searchFilters.startDate, "YYYY-MM-DD")} // Correct way to set minDate
                value={moment(searchFilters.endDate, "YYYY-MM-DD")}
                onChange={(e) => {
                  setSearchFilters({
                    ...searchFilters,
                    endDate: moment(e).format("YYYY-MM-DD"),
                  });
                  updateReservationList("page", 1);
                  handleTriggerLoadingFailed();

                }}
                slotProps={{
                  textField: {
                    readOnly: true,
                  },
                }}
              />
            </FormControl>
          </Grid>
          <Grid item md={3} xs={6}>
            <FormControl fullWidth>
              <Typography
                id="font-600"
                style={{
                  marginBottom: "11px",
                  color: "rgb(30, 30, 30)",
                  fontSize: "16px",
                  lineHeight: "24px",
                  fontWeight: "500 !important",
                }}
              >
                {t("Payment Type")}
              </Typography>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={searchFilters?.payment_type}
                //label="Room Status"
                onChange={handlePaymentTypeChange}
              >
                <MenuItem value={0}>{t("Select Payment Type")}</MenuItem>
                {paymentTypeList?.map((data) => (
                  <MenuItem value={data.id} key={data.id}>
                    {data.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item md={ 3} xs={6}>
            <FormControl fullWidth>
              <Typography
                id="font-600"
                style={{
                  marginBottom: "11px",
                  color: "rgb(30, 30, 30)",
                  fontSize: "16px",
                  lineHeight: "24px",
                  fontWeight: "500 !important",
                }}
              >
                {t("Booking Type")}
              </Typography>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={searchFilters?.booking_type}
                //label="Room Status"
                onChange={handleBoookingTypeChange}
              >
                <MenuItem value={0}>{t("Select Booking Type")}</MenuItem>
                {bookingTypeList?.map((data) => (
                  <MenuItem value={data.id} key={data.id}>
                    {data.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item md={ 3} xs={6}>
            <FormControl fullWidth>
              <Typography
                id="font-600"
                style={{
                  marginBottom: "11px",
                  color: "rgb(30, 30, 30)",
                  fontSize: "16px",
                  lineHeight: "24px",
                  fontWeight: "500 !important",
                }}
              >
                {t("Booking Status")}
              </Typography>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={searchFilters.booking_status}
                //label="Room Status"
                onChange={handleBoookingStatusChange}
              >
                <MenuItem value={0}>{t("Select Booking Status")}</MenuItem>
                {bookingStatus?.map((data) => (
                  <MenuItem value={data.id} key={data.id}>
                    {data.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item md={ 3} xs={6}>
            <FormControl fullWidth>
              <Typography
                id="font-600"
                style={{
                  marginBottom: "11px",
                  color: "rgb(30, 30, 30)",
                  fontSize: "16px",
                  lineHeight: "24px",
                  fontWeight: "500 !important",
                }}
              >
                {t("Booking Source")}
              </Typography>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={searchFilters.booking_source}
                //label="Room Status"
                onChange={handleBoookingSourceChange}
              >
                <MenuItem value={0}>{t("Select Booking Source")}</MenuItem>
                {bookingSource?.map((data) => (
                  <MenuItem value={data.id} key={data.id}>
                    {data.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          {searchFilters?.booking_source === 3 && (
            <Grid item lg={3} md={3} xs={6}>
              <FormControl fullWidth>
                <Typography
                  id="font-600"
                  style={{
                    marginBottom: "11px",
                    color: "rgb(30, 30, 30)",
                    fontSize: "16px",
                    lineHeight: "24px",
                    fontWeight: "500 !important",
                  }}
                >
                  {t("OTA Source")}
                </Typography>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={searchFilters.ota_source}
                  //label="Room Status"
                  onChange={handleBoookingOtaSourceChange}
                >
                  <MenuItem value={0}>{t("Select OTA Source")}</MenuItem>
                  {otaCodeList?.map((data) => (
                    <MenuItem value={data.name} key={data.value}>
                      {data.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          )}
          <Grid item lg={12} md={12} xs={12}>
            <div className="d-flex justify-content-end">
              <Button
                className="mb-1 comman-button"
                size="large"
                variant="contained"
                onClick={() => reservationViewReset()}
                disableElevation
                color="primary"
              >
                {t("Clear")}
              </Button>
            </div>
          </Grid>
        </Grid>
        <div className="w-100">
          <DataGrid
            density="compact"
            autoHeight
            localeText={
              getLanguageCode().components.MuiDataGrid.defaultProps.localeText
            }
            getRowHeight={() => "auto"}
            pagination
            paginationMode="server"
            loading={dataReservationList.loading}
            rowCount={dataReservationList.totalRows}
            rowsPerPageOptions={dataReservationList.rowsPerPageOptions}
            // rows={ratesDatagridRows}
            rows={dataReservationList?.rows}
            columns={datagridColumns}
            page={dataReservationList.page - 1}
            pageSize={dataReservationList.pageSize}
            //onRowClick={(params)=>handlevivew(params.row.booking_id)}
            checkboxSelection={false}
            onPageChange={(newPage) => {
              // setDataReservationList((old) => ({
              //   ...old,
              //   page: newPage + 1,
              // }));
              dataReservationListSuccess({key: "page", value: newPage + 1});
              handleTriggerLoadingFailed();
            }}
            onPageSizeChange={(pageSize) => {
              console.log("page size", pageSize);
              updateReservationList("page", 1);
              updateReservationList("pageSize", pageSize);
              handleTriggerLoadingFailed();

            }}
            sx={{
              [`& .MuiDataGrid-cell, & .MuiDataGrid-columnHeader`]: {
                [theme.breakpoints.down("sm")]: {
                  // Adjust styles for small screens
                  fontSize: "12px", // Adjust font size
                  padding: "8px", // Adjust padding
                  minWidth: "75px !important",
                },
                // Add other styles for larger screens if needed
              },
            }}
          />
          {/* </div> */}
        </div>
      </div>

      <DialogForm
        scroll="paper"
        maxWidth="lg"
        title={t("Confirm Check In")}
        openDialog={openDialog}
        handleDialogClose={handleDialogClose}
        bodyContent={
          <ReservationCheckIn
            handleDialogClose={handleDialogClose}
            refreshCheckInOutListCall={getReservationList}
            // refreshCheckInOutListCall={refreshCheckInOutList}
            editedData={editedData}
            suToken={suToken}
            suOn={suOn}
            handleSuOn={handleSuOn}
            setOpenMakePaymentDialog={setOpenMakePaymentDialog}
            setShowPaymentMessage={setShowPaymentMessage}
          /> 
        }
      />
      <MakePaymentDialog
        open={openMakePaymentDialog}
        onClose={() => setOpenMakePaymentDialog(false)}
        bookingId={editedData?.id}
        bookingDetail={editedData}
        showNote={showPaymentMessage}
        onSuccess={() => {
          handleEdit(editedData?.id, 0); // refreshes editedData shown in the check-in form
          getReservationList();          // refreshes the grid
        }}
      />
      

      <DialogForm
        scroll="paper"
        maxWidth="lg"
        title={t("Select check-out method")}
        openDialog={openDialogout}
        handleDialogClose={handleDialogOutClose}
        bodyContent={
          <ReservationCheckOut
            handleDialogOutClose={handleDialogOutClose}
            // refreshCheckInOutListCall={refreshCheckInOutList}
            refreshCheckInOutListCall={getReservationList}
            editedData={editedData}
            isCashAllowed={isCashAllowed}
          />
        }
      />

      {/* Fix Tax Dialog */}
          <DialogForm
        scroll="paper"
        maxWidth="lg"
        title={t("Update Tax Action")}
        openDialog={openFixTaxDialog}
        handleDialogClose={handleCloseFixTaxDialog}
        bodyContent={
          <UpdateTaxPopup
            handleExtendDialogClose={handleCloseFixTaxDialog}
            getReservationList={getReservationList}
            editedData={editedData}
          />
        }
      />
 
      <ConfirmDialog
        scroll="paper"
        maxWidth="md"
        title={t("Confirm The Action")}
        message={t(
          "Do you want to charge a cancellation amount to cancel the reservation?"
        )}
        cancelButtonText={t("No")}
        confirmButtonText={t("Yes")}
        openDialog={openCancelReservationDialog}
        handleDialogClose={handleCloseCancelReservationDialog}
        handleDialogCloseAction={() => {
          setChargeCancellationAmount(0);
          handleConfirmOpenSmsEmail(2);
        }}
        handleDialogAction={() => {
          setChargeCancellationAmount(1);
          handleConfirmOpenSmsEmail(2);
        }}
      />

      <ConfirmDialog
        scroll="paper"
        maxWidth="md"
        title={t("Confirm The Action")}
        message={t("Do you really want to Void Transaction?")}
        cancelButtonText={t("Cancel")}
        confirmButtonText={t("Void Transaction")}
        openDialog={openVoidDialog}
        handleDialogClose={handleVoidDialog}
        handleDialogAction={handleConfirmVoidAction}
      />

      {/* <ConfirmDialog
        scroll="paper"
        maxWidth="md"
        title="Confirm The Action"
        message="Do you really want to Refund Transaction?"
        cancelButtonText="Cancel"
        confirmButtonText="Refund Transaction"
        openDialog={openRefundDialog}
        handleDialogClose={handleRefundDialog}
        handleDialogAction={handleConfirmRefundAction}
      /> */}

      <DialogForm
        scroll="paper"
        // maxWidth="lg"
        maxWidth="mb"
        title={t("Refund Transaction")}
        openDialog={openRefundDialog}
        handleDialogClose={handleRefundDialog}
        bodyContent={
          <div className="p-2">
            <h6 className="mb-1">{t("Amount")}</h6>
            <Grid container spacing={2} alignItems="flex-start">
              <Grid item lg={12}>
                <TextField
                  onChange={(e) => setRefundAmount(e.target.value)}
                  variant="outlined"
                  type="number"
                  placeholder={t("Enter Amount")}
                />
              </Grid>
              <Grid item lg={12}>
                <Button
                  className="mt-1 comman-button"
                  size="large"
                  variant="contained"
                  onClick={handleConfirmRefundAction}
                  disableElevation
                  color="primary"
                  // style={{
                  //   justifyContent: "center",
                  //   width: "98px",
                  //   height: "44px",
                  //   textTransform: "capitalize",
                  //   background:
                  //     "linear-gradient(180deg, #255480 0%, #173450 100%)",
                  // }}
                >
                  {t("Submit")}
                </Button>
              </Grid>
            </Grid>
          </div>
        }
      />

      {/* change booking status */}

      <ChangeReservationStatus
        openChangeBookingStatus={openChangeBookingStatus}
        handleChangeBookingStatus={handleChangeBookingStatus}
        bookingStatusValue={bookingStatusValue}
        setBookingStatusValue={setBookingStatusValue}
        handleConfirmBookingStatus={() => handleConfirmOpenSmsEmail(1)}
      />

      {/* //add payment  */}
      <DialogForm
        scroll="paper"
        maxWidth="lg"
        // maxWidth="mb"
        title={t("Add Payment")}
        openDialog={openChangePaymentDialog}
        handleDialogClose={handleChangePaymentDialog}
        bodyContent={
          <div className="p-2">
            <Grid container spacing={2} alignItems="flex-start">
              {/* <Grid item lg={3} className="mt-2">
                  <Typography
                    variant="h4"
                    style={{
                      marginBottom: "11px",
                      color: "rgb(30, 30, 30)",
                      fontSize: "16px",
                      lineHeight: "24px",
                    }}
                  >
                    {t("Payment Option")}
                  </Typography>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">
                      {t("Paymnet Type")}
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      value={paymentType}
                      label="Paymnet Type"
                      onChange={(e) => handalepaymentType(e)}
                    >
                      <MenuItem value={1}>{t("Cash")}</MenuItem>
                      <MenuItem value={2}>{t("Credit Card")}</MenuItem>
                      <MenuItem value={3}>{t("Cheque")}</MenuItem>
                      <MenuItem value={4}>{t("Direct Bill")}</MenuItem>
                    </Select>
                  </FormControl>
                </Grid> */}
              {/* <Grid item lg={3} style={{ left: "20px" }} className="mt-2"> */}
              {/* {paymentType === 2 && (
                    <>
                      <Typography
                        variant="h4"
                        style={{
                          marginBottom: "11px",
                          color: "rgb(30, 30, 30)",
                          fontSize: "16px",
                          lineHeight: "24px",
                        }}
                      >
                        {t("Card Present")}
                      </Typography>
                      <FormControlLabel
                        control={
                          <IOSSwitch
                            sx={{ m: 1 }}
                            checked={card_present}
                            onChange={(e) => handaleCardPresent(e)}
                          />
                        }
                        label={""}
                      />
                    </>
                  )} */}
              {/* </Grid> */}
              {card_present === false && paymentType === 2 && (
                <Grid
                  container
                  spacing={2}
                  style={{
                    marginLeft: "20px",
                    border: "2px solid #B4ADAD",
                    borderRadius: "5px",
                    width: "97%",
                    marginTop: "25px",
                    height: "auto",
                    paddingBottom: "10px",
                  }}
                >
                  <Grid item lg={2}>
                    <Typography
                      id="font-600"
                      style={{
                        marginBottom: "11px",
                        color: "rgb(30, 30, 30)",
                        fontSize: "16px",
                        lineHeight: "24px",
                      }}
                    >
                      {t("Select Card")}
                    </Typography>
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">
                        {t("Select Card")}
                      </InputLabel>
                      <Select
                        // style={{ width: '200px' }}
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        onChange={(e) => setCradsDetail(e)}
                        value={card?.id}
                        // value={card?.user_id}
                        // value={cancelPolicy}
                        label="Select Card"
                      >
                        <MenuItem value={0}>{t("Add Card")}</MenuItem>
                        {cardDetail.map((item) => (
                          <MenuItem value={item.id} key={item.id}>
                            {item.card_holder_name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item lg={3}>
                    <Typography
                      id="font-600"
                      style={{
                        marginBottom: "11px",
                        color: "rgb(30, 30, 30)",
                        fontSize: "16px",
                        lineHeight: "24px",
                      }}
                    >
                      {t("Card Holder Name")}
                    </Typography>
                    <TextField
                      value={card?.card_holder_name}
                      disabled={
                        !(card?.id == 0 || Number.isNaN(card?.id))
                      }
                      placeholder={t("Card Holder Name")}
                      onChange={(e) => handeleCardChange(e)}
                      name="card_holder_name"
                      id="group_name"
                    />
                  </Grid>
                  <Grid item lg={3}>
                    <Typography
                      id="font-600"
                      style={{
                        marginBottom: "11px",
                        color: "rgb(30, 30, 30)",
                        fontSize: "16px",
                        lineHeight: "24px",
                      }}
                    >
                      {t("Card Number")}
                    </Typography>
                    <TextField
                      value={card?.card_number}
                      placeholder={t("Card Number")}
                      disabled={
                        !(card?.id == 0 || Number.isNaN(card?.id))
                      }
                      // type={
                      //   card?.id == 0 || Number.isNaN(card?.id) ? "number" : ""
                      // }
                      type="text" // Change from "number" to "text"
                      inputMode="numeric" // Ensures only numbers show up in the keyboard
                      name="card_number"
                      onChange={(e) => {
                        const value = e.target.value.replaceAll(/\D/g, ""); // Remove non-numeric characters
                        if (value?.length > 16) {
                          return;
                        }
                        handeleCardChange({
                          target: { name: e.target.name, value },
                        });
                      }}
                      id="group_name"
                    />
                  </Grid>
                  <Grid item lg={1}>
                    <Typography
                      id="font-600"
                      style={{
                        marginBottom: "11px",
                        color: "rgb(30, 30, 30)",
                        fontSize: "16px",
                        lineHeight: "24px",
                      }}
                    >
                      {t("Expiry")}
                    </Typography>
                    <FormControl fullWidth>
                      <InputLabel title={"Month"}>{"MM"}</InputLabel>
                      <Select
                        name="mm"
                        input={<OutlinedInput label="MM" />}
                        label="Month"
                        disabled={
                          !(card?.id == 0 || Number.isNaN(card?.id))
                        }
                        onChange={(e) => handeleCardChange(e)}
                        value={card?.mm + ""}
                      >
                        <MenuItem value={""}>{t("MM")}</MenuItem>
                        {month.map((item) => (
                          <MenuItem key={item} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item lg={1}>
                    <Typography
                      id="font-600"
                      style={{
                        marginBottom: "35px",
                        color: "rgb(30, 30, 30)",
                        fontSize: "16px",
                        lineHeight: "24px",
                      }}
                    >
                      {" "}
                    </Typography>
                    <FormControl fullWidth>
                      <InputLabel title={"Year"}>{"YYYY"}</InputLabel>
                      <Select
                        name="yyy"
                        input={<OutlinedInput label="YYYY" />}
                        label="Year"
                        disabled={
                          !(card?.id == 0 || Number.isNaN(card?.id))
                        }
                        onChange={(e) => handeleCardChange(e)}
                        value={card?.yyy + ""}
                      >
                        <MenuItem value={""}>{t("YYYY")}</MenuItem>
                        {yearList.map((item) => (
                          <MenuItem key={item} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  {card?.id == 0 || Number.isNaN(card?.id) ? (
                    <Grid item lg={1.8}>
                      <Typography
                        id="font-600"
                        style={{
                          marginBottom: "11px",
                          color: "rgb(30, 30, 30)",
                          fontSize: "16px",
                          lineHeight: "24px",
                        }}
                      >
                        {t("Security Code")}
                      </Typography>
                      <TextField
                        value={card?.cvv}
                        disabled={
                          !(card?.id == 0 || Number.isNaN(card?.id))
                        }
                        onChange={(e) => handeleCardChange(e)}
                        placeholder={t("CVV")}
                        name="cvv"
                        id="cvv"
                        type="number"
                      />
                    </Grid>
                  ) : (
                    <Grid item lg={1.3}>
                      <Typography
                        id="font-600"
                        style={{
                          marginBottom: "11px",
                          color: "rgb(30, 30, 30)",
                          fontSize: "16px",
                          lineHeight: "24px",
                        }}
                      >
                        {t("Card Type")}
                      </Typography>
                      <TextField
                        value={card?.card_type}
                        disabled={
                          !(card?.id == 0 || Number.isNaN(card?.id))
                        }
                        // onChange={(e) => handeleCardChange(e)}
                        placeholder={t("Card Type")}
                        name="Card Type"
                        id="Card Type"
                      />
                    </Grid>
                  )}
                  {card?.id == 0 || Number.isNaN(card?.id) ? (
                    <Grid item lg={1.5}>
                      <Typography
                        id="font-600"
                        style={{
                          marginBottom: "11px",
                          color: "rgb(30, 30, 30)",
                          fontSize: "16px",
                          lineHeight: "24px",
                        }}
                      ></Typography>
                      <Button
                        variant="contained"
                        onClick={addCardDetail}
                        title="Cancel"
                        style={{
                          width: "150px",
                          height: "47px",
                          marginTop: "23px",
                        }}
                      >
                        {t("Add & Verify")}
                      </Button>
                    </Grid>
                  ) : (
                    ""
                  )}
                  {/* {card?.id !== 0 ? (
                        <Grid item lg={1.5}>
                          <Typography
                            style={{
                              marginBottom: "11px",
                              color: "rgb(30, 30, 30)",
                              fontSize: "16px",
                              lineHeight: "24px",
                            }}
                          ></Typography>
                          <Button
                            variant="contained"
                            onClick={CardDetailVerify}
                            // title="Cancel"
                            style={{
                              width: "93px",
                              height: "47px",
                              // left: "15px",
                              marginTop: "23px",
                            }}
                          >
                            {t("Verify")}
                          </Button>
                        </Grid>
                      ) : 
                      (
                        ""
                      )} */}
                </Grid>
              )}
              {card_present === true && paymentType === 2 && (
                <Grid
                  container
                  spacing={2}
                  style={{
                    marginLeft: "15px",
                    border: "2px solid #B4ADAD",
                    borderRadius: "5px",
                    width: "90%",
                    marginTop: "25px",
                    height: "135px",
                  }}
                >
                  <Grid item lg={4}>
                    <Typography
                      id="font-600"
                      style={{
                        marginBottom: "11px",
                        color: "rgb(30, 30, 30)",
                        fontSize: "16px",
                        lineHeight: "24px",
                      }}
                    >
                      {t("Pinpad Devices")}
                    </Typography>
                    <FormControl fullWidth>
                      <Select
                        onChange={(e) => handlePinpadDevice(e)}
                        defaultValue={0}
                      >
                        <MenuItem value={0}>{t("-- select --")}</MenuItem>
                        {pinpadDevicesList?.map((item) => (
                          <MenuItem value={item.id} key={item.id}>
                            {item.device_id}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              )}
              {/* <Grid item lg={12}>
                  <Button
                    className="mt-1"
                    size="large"
                    variant="contained"
                    disableElevation
                    color="primary"
                    style={{
                      justifyContent: "center",
                      width: "98px",
                      height: "44px",
                      textTransform: "capitalize",
                      background:
                        "linear-gradient(180deg, #255480 0%, #173450 100%)",
                    }}
                  >
                    {t("Submit")}
                  </Button>
                </Grid> */}
            </Grid>
          </div>
        }
      />

      {/* Change Payment Type */}

      <ChangeStatusReservationDialog
        openChangePaymentTypeDialog={openChangePaymentTypeDialog}
        handleChangePaymentTypeDialog={handleChangePaymentTypeDialog}
        handalepaymentType={handalepaymentType}
        handaleCardPresent={handaleCardPresent}
        card_present={card_present}
        paymentType={paymentType}
        setCradsDetail={setCradsDetail}
        cardDetail={cardDetail}
        card={card}
        handeleCardChange={handeleCardChange}
        month={month}
        yearList={yearList}
        addCardDetail={addCardDetail}
        handlePinpadDevice={handlePinpadDevice}
        pinpadDevicesList={pinpadDevicesList}
        handlePaymentTypeSubmit={handlePaymentTypeSubmit}
        selectPinpadDevices={selectPinpadDevices}
        reservationDetail={selectDetail}
        isCashAllowed={isCashAllowed}
      />

      <SendSmsDialog
        openSendSmsDialog={openSendSmsDialog}
        handleChangeSmsDialog={handleChangeSmsDialog}
        handleSendAgreement={handleSendAgreement}
        selectDetail={selectDetail}
        handleSendFolioReceipt={handleSendFolioReceipt}
        smsInitialValue={smsInitialValue}
        handleSendSms={handleSendSms}
        setSmsInitialValue={setSmsInitialValue}
        handleSendAgreementEmail={handleSendAgreementEmail}
        handleSendFolioReceiptEmail={handleSendFolioReceiptEmail}
        emailInitialValue={emailInitialValue}
        handleSendEmail={handleSendEmail}
        smsUserDetail={smsUserDetail}
        setEmailInitialValue={setEmailInitialValue}
      />

      <ConfirmDialog
        scroll="paper"
        maxWidth="md"
        title={t("Confirm The Action")}
        message={t("Do you really want to No Show Reservation?")}
        cancelButtonText={t("Cancel")}
        confirmButtonText={t("No Show Reservation")}
        openDialog={openNoShowReservationDialog}
        handleDialogClose={handleCloseNoShowReservationDialog}
        handleDialogAction={() => handleConfirmOpenSmsEmail(3)}
        // inputName= {"remark"}
        // handleInputText = {(e)=>console.log(e.target.value, 3184)}
      />
      {/* <FormikInput /> */}

      {/* add Remark */}

      <ConfirmDialog
        scroll="paper"
        maxWidth="md"
        title={t("Add Remark")}
        message={t("Remark")}
        cancelButtonText={t("Cancel")}
        confirmButtonText={t("Submit")}
        openDialog={openRemarkDialog}
        handleDialogClose={handleCloseRemarkDialog}
        handleDialogAction={handleConfirmRemarkAction}
        inputName={"Write Remark..."}
        handleInputText={(e) => setRemarkValue(e.target.value)}
      />

      {/* send sms/email confirm dialog */}

      <ConfirmDialog
        scroll="paper"
        maxWidth="md"
        title={t("Confirm The Action")}
        message={t("Do you want to send sms/email to the user?")}
        cancelButtonText={t("No")}
        confirmButtonText={t("Yes")}
        openDialog={openConfirmSendSmsEmailDialog}
        handleDialogCloseAction={handleNoSendSms}
        handleDialogClose={() => setOpenConfirmSendSmsEmailDialog(false)}
        handleDialogAction={handleYesSendSms}
      />

      {/* Delete Duplicate confirm dialog */}

      <ConfirmDialog
        scroll="paper"
        maxWidth="md"
        title={t("Confirm The Action")}
        message={t("Do you want to delete booking ?")}
        cancelButtonText={t("No")}
        confirmButtonText={t("Yes")}
        openDialog={openConfirmDeleteDuplicateDialog}
        handleDialogClose={() => setOpenConfirmDeleteDuplicateDialog(false)}
        handleDialogAction={handleConfirmDeleteDuplicateReservationAction}
      />
    </div>
  );
};

const mapStateToProps = (state, ownProps) => {
  return {
    state: state,
    checkInCheckOutList: ownProps.checkInCheckOutList,
    guestList: state.report.guestList,
    searchFilters: state.filters.reservationView,
    dataReservationList: state.reservationList.dataReservationList,
    handleTriggerLoading: state.reservationList.handleTriggerLoading,
    otaCodeList: state.reservationList.otaCodeList,
    pinpadDevicesList: state.reservationList.pinpadDevicesList
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    dataReservationListSuccess: (data) => dispatch(dataReservationListSuccess(data)),
    guestListSuccess: (data) => dispatch(guestListSuccess(data)),
    guestListFailed: () => dispatch(guestListFailed()),
    getLoadingSuccess: () => dispatch(getLoadingSuccess()),
    getLoadingFailed: () => dispatch(getLoadingFailed()),
    setSearchFilters: (data) => dispatch(reservationViewChange(data)),
    reservationViewReset: () => dispatch(reservationViewReset()),
    handleTriggerLoadingSuccess: () => dispatch(handleTriggerLoadingSuccess()),
    handleTriggerLoadingFailed: () => dispatch(handleTriggerLoadingFailed()),
    otaCodeListSuccess: (data) => dispatch(otaCodeListSuccess(data)),
    otaCodeListFailed: () => dispatch(otaCodeListFailed()),
    pinpadDevicesListSuccess: (data) => dispatch(pinpadDevicesListSuccess(data)),
    pinpadDevicesListFailed: () => dispatch(pinpadDevicesListFailed()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(ReservationView);
